import { createContext } from 'react';
export var historyContext = createContext(null);
